<template>
  <line-chart-wrapper
    v-if="loaded"
    :initial-options="chartData.options"
    :initial-data="chartData.chartData"
  />
</template>

<script>
import LineChartWrapper from './LineChartWrapper.vue';
import FUEL_CONSUMPTION_CHART_DATA from '@/graphql/statistics/fuelConsumptionChartData.gql';

export default {
  components: { LineChartWrapper },
  data() {
    return {
      loaded: false,
      chartData: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: 'Average fuel consumption',
              backgroundColor: '#000',
              borderColor: '#000',
              pointStyle: null,
              fill: false,
              data: [],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            point: {
              radius: 0,
            },
          },
          scales: {
            yAxes: [{
              ticks: {
                suggestedMin: 0,
                suggestedMax: 50,
              },
            }],
          },
        },
      },
    };
  },
  apollo: {
    fuelConsumptionChartData: {
      query: FUEL_CONSUMPTION_CHART_DATA,
      variables() {
        return {
          carId: this.$route.params.id,
        };
      },
      result({ data }) {
        this.chartData.chartData.datasets[0].data = data.fuelConsumptionChartData.data;
        this.chartData.chartData.labels = data.fuelConsumptionChartData.labels;
        this.loaded = true;
      },
    },
  },
};
</script>

<style scoped>

</style>
